// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mmd-table, .mmd-table td, .mmd-table th {
  padding: 0.25rem !important;
  font-size: 0.85rem;
}
.mmd-table .form-control, .mmd-table td .form-control, .mmd-table th .form-control {
  font-size: 0.85rem;
  padding: 2px;
  line-height: 1.2rem;
  height: auto;
  font-weight: 500;
}

.full-width {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  padding-bottom: 100px;
}

.opacity-100 {
  opacity: 1;
}

.left-bar {
  flex: 0 0 200px;
}

.sidebar td, .sidebar th {
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.25rem !important;
}

.mmd-table .col-1 {
  min-width: 250px;
}

.mmd-table .col-2 {
  min-width: 170px;
}

.mmd-table .col-3 {
  min-width: 370px;
}

.mmd-table tr.row-selected {
  background-color: lightgreen !important;
}

.mmd-table tr.row-pending, .mmd-table tr.row-pending.row-selected {
  background-color: lightpink !important;
}

.table-striped tbody tr.status-2 {
  background-color: lightblue !important;
}
.table-striped tbody tr.status-3 {
  background-color: lightpink !important;
}

.please-wait {
  position: absolute;
  right: 15px;
  top: 7px;
}

.pending-checkbox {
  width: 25px !important;
  height: 25px !important;
  vertical-align: middle;
  margin-left: 3px;
  pointer-events: auto;
  position: relative;
}

.merge-cell {
  display: inline-block;
  width: 50px;
}
.merge-cell::-webkit-input-placeholder {
  font-size: 10px;
}

.main-section {
  padding-left: 40px;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/maintenance/alt/mmd/mmd.component.scss"],"names":[],"mappings":"AAAA;EAEE,2BAAA;EACA,kBAAA;AAAF;AAEE;EAEE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AADJ;;AAKA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,uCAAA;AAHF;;AAOA;EACE,sCAAA;AAJF;;AAQE;EACE,sCAAA;AALJ;AAQE;EACE,sCAAA;AANJ;;AAUA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAPF;;AAUA;EACE,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAPF;;AAWA;EAEE,qBAAA;EACA,WAAA;AATF;AAWE;EAEE,eAAA;AAVJ;;AAcA;EACE,kBAAA;AAXF","sourcesContent":[".mmd-table, .mmd-table td, .mmd-table th {\n\n  padding: 0.25rem !important;\n  font-size: 0.85rem;\n\n  .form-control {\n\n    font-size: 0.85rem;\n    padding: 2px;\n    line-height: 1.2rem;\n    height: auto;\n    font-weight: 500;\n  }\n}\n\n.full-width {\n  display: flex;\n  flex-wrap: nowrap;\n  width: 100%;\n  padding-bottom: 100px;\n}\n\n.opacity-100 {\n  opacity: 1;\n\n}\n\n.left-bar {\n  flex: 0 0 200px\n}\n\n.sidebar td, .sidebar th {\n  font-size: 0.75rem;\n  font-weight: 500;\n  padding: 0.25rem !important\n}\n\n.mmd-table .col-1 {\n  min-width: 250px;\n}\n\n.mmd-table .col-2 {\n  min-width: 170px;\n}\n\n.mmd-table .col-3 {\n  min-width: 370px;\n}\n\n.mmd-table tr.row-selected {\n  background-color: lightgreen !important;\n}\n\n\n.mmd-table tr.row-pending, .mmd-table tr.row-pending.row-selected {\n  background-color: lightpink !important;\n}\n\n.table-striped tbody {\n  tr.status-2 {\n    background-color: lightblue !important;\n  }\n\n  tr.status-3 {\n    background-color: lightpink !important;\n  }\n}\n\n.please-wait {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n}\n\n.pending-checkbox {\n  width: 25px !important;\n  height: 25px !important;\n  vertical-align: middle;\n  margin-left: 3px;\n  pointer-events: auto;\n  position: relative;\n}\n\n\n.merge-cell {\n\n  display: inline-block;\n  width: 50px;\n\n  &::-webkit-input-placeholder {\n\n    font-size: 10px;\n  }\n}\n\n.main-section {\n  padding-left: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
